import React from "react";
import Accordion from "../../../share/Accordion/Accordion ";

function PopularQuestions() {
  return (
    <div id="faq" className="container scroll-mt-28">
      <h2 className="text-md primary-dark items-center flex justify-center mb-[3.2rem] font-bold mt-[7rem]">
        سوالات متداول{" "}
      </h2>
      <div className="PopularQuestions">
        {Acco.map((item, id) => (
          <Accordion label={item.title} id={id} key={id}>
            {item.text}
          </Accordion>
        ))}
      </div>
    </div>
  );
}

export default PopularQuestions;

const Acco = [
  {
    title: "نحوه شرکت در یک وبینار به چه صورت است و چه مراحلی باید طی شود؟",
    text: "به سادگی و با ثبت‌نام در سایت به عنوان برگزار‌کننده و یا شرکت‌کننده می‌توانید وارد داشبورد خود شوید و از مزایای بی‌شمار بوت‌وب بهر‌ه‌مند شوید",
  },
  {
    title: "هزینه برگزاری هر وبینار به چه صورت محاسبه می‌شود؟ ",
    text: "هزینه‌‌ی برگزاری وبینارها، توسط سیستم هوشمند بوت‌وب و بر اساس معیارهایی مانند پلتفرم مورد نیاز شما، میزان حجم مورد استفاده، تعداد شرکت‌کنندگان و دیگر موارد محاسبه می‌شود",
  },
  {
    title: "برای برگزاری و یا شرکت در یک وبینار به چه تجهیزاتی نیاز است؟",
    text: "شما می‌توانید با استفاده از موبایل، تبلت، لپتاپ و حتی کامپیوترهای شخصی خود و اتصال آن‌ها به اینترنت با پایداری مناسب وارد وبینار دلخواه خود شوید. البته توجه داشته باشید برای صحبت‌کردن به صورت صوتی و یا نمایش تصویر خود نیاز به یک میکروفون با کیفیت و وبکم خواهید داشت که پیشنهاد می‌کنیم قبل از ورود به وبینار آن‌ها را آماده و امتحان کنید",
  },
  {
    title: "آیا امکان کسب درآمد از طریق برگزاری وبینار در بوت‌وب فراهم است؟ ",
    text: "برگزارکنندگان وبینارها می‌توانند با ایجاد وبینارهای خصوصی و فروش بلیت آن به افراد علاقمند و جذب آن‌ها به شرکت در وبینار، درآمد قابل توجهی را از طریق این بستر کسب کنند",
  },
  {
    title: "بسترهای برگزاری وبینارها چیست و کدام یک برای من بهتر است؟",
    text: "بسترهای متفاوتی برای برگزارگنندگان وبینارها در بوت‌وب در نظر گرفته شده است تا بتواند نیازهای متفاوت افراد را پوشش دهد. تمامی بسترهای ارائه شده در بوت‌وب از کیفیت بالایی برخوردارند و تنها نیازهای شماست که مشخص می‎کند کدام بستر برای وبینار شما بهتر است. برای مقایسه بسترها می‌توانید سری به سربرگ امکانات بزنید",
  },
];
